import { StateModel } from './state-model';
import { CountryModel } from './country-model';
import { ValidationMessageModel } from './validation-message-model';

export class AddressModel {
  public id: number;
  public city: string;
  public line1: string;
  public line2?: string;
  public line3?: string;
  public postalCode: string;
  public state: StateModel;
  public country: CountryModel;
  public validationMessages?: [{ [key: string]: ValidationMessageModel }];
  public lastModified: string; // Date

  constructor(address?: Partial<AddressModel>) {
    this.id = 0;
    this.city = null;
    this.line1 = null;
    this.line2 = null;
    this.line3 = null;
    this.postalCode = null;
    this.state = null;
    this.country = null;

    Object.assign(this, address);
  }
}
